import { useAppDispatch } from 'store/hooks';
import mediaSelectors from '../selectors';
import mediaActions from '../actions';
import { useEffect } from 'react';

const useGetAllFoldersInStore = (storeId: string, isLazy = false) => {
  const dispatch = useAppDispatch();
  const data = mediaSelectors.getAllFoldersInStore();

  const mutate = () => {
    dispatch(mediaActions.getAllFoldersInStore.fetch({ storeId }));
  };

  useEffect(() => {
    if (!isLazy && storeId && !data) {
      mutate();
    }
  }, []);

  return [data, mutate] as const;
};

export default useGetAllFoldersInStore;
